import { h } from 'preact'
import Phrase from '../../../libs/translationsUtils/phrase'
import { IdeaStatus } from '@insided/control/modules/ContentModeration/TopicModeration/interfaces'
import IdeationStatus from '../IdeationStatus'

interface Props {
  oldIdeationStatus: IdeaStatus
  newIdeationStatus: IdeaStatus
  toIdeaUrl: string
}

const FromReply = ({ oldIdeationStatus, newIdeationStatus, toIdeaUrl }: Props) => {
  const statusChanged = oldIdeationStatus.id !== newIdeationStatus.id

  return (
    <div>
      {statusChanged &&
        <div>
          <Phrase p='reply.idea.status.changed' m='Common' />
          <IdeationStatus
            ideationStatus={oldIdeationStatus}
          />
          →
          <IdeationStatus
            ideationStatus={newIdeationStatus}
          />
        </div>}
      <Phrase p='idea.merge.from' m='Control' />
      <br />
      <oembed url={toIdeaUrl} />
      <br />
      <Phrase p='idea.merge.from.votes' m='Control' />
    </div>
  )
}

export default FromReply
